/** Horodatage : heure locale + heure d’enregistrement. */
import { formatClock } from "./display";

type ClockLineProps = {
  iso?: string | null;
  zone?: string;
  extra?: string;
};

export function ClockLine({ iso, zone = "UTC", extra }: ClockLineProps) {
  const clock = formatClock(iso, zone);
  return (
    <>
      {clock.primary}
      {clock.primary !== "—" ? (
        <small>
          {clock.extra}
          {extra ? ` · ${extra}` : ""}
        </small>
      ) : extra ? (
        <small>{extra}</small>
      ) : null}
    </>
  );
}
